import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { navigation, contact } from '../data/site';
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-200 ease-smooth ${scrolled || open ? 'bg-paper/95 backdrop-blur border-b border-line' : 'bg-transparent'}`} data-id="element-178" data-mp="qy8bw4w9zm45">
      <div className="mx-auto flex max-w-shell items-center justify-between px-6 py-5 lg:px-10" data-id="element-179" data-mp="zzeucjihj701">
        <Link to="/" className="group flex items-baseline gap-3" aria-label="DACB — accueil" data-id="element-180" data-mp="2gdoipdmq8vqv">
          <span className="font-display text-2xl leading-none tracking-tight" data-id="element-181" data-mp="2bc8z7q076xal">DACB</span>
          <span className="hidden text-[11px] uppercase tracking-label text-graphite sm:block" data-id="element-182" data-mp="29jadr2npdk34">
            Dessin d’architecture
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="hidden items-center gap-9 md:flex" data-id="element-183" data-mp="2jhge3ftv2i5v">
          {navigation.map(item => <Link key={item.to} to={item.to} className="relative text-sm text-ink/80 transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-184" data-mp="2ogkr6hjwp01h">
              {item.label}
            </Link>)}
          <a href={contact.phoneHref} className="border border-ink px-5 py-2.5 text-[11px] uppercase tracking-label transition-colors duration-150 ease-smooth hover:bg-ink hover:text-paper" data-id="element-185" data-mp="20qyq1ojz4aqu">
            Parlons de votre projet
          </a>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} className="md:hidden" aria-expanded={open} aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-186" data-mp="1d1nzezwc7wqf">
          {open ? <XIcon className="h-6 w-6" data-id="element-187" data-mp="101dfwesxsuha" /> : <MenuIcon className="h-6 w-6" data-id="element-188" data-mp="1002e2kj1xwst" />}
        </button>
      </div>

      {open && <nav aria-label="Navigation mobile" className="border-t border-line px-6 pb-6 pt-2 md:hidden" data-id="element-189" data-mp="1eq9k20rvhncm">
          {navigation.map(item => <Link key={item.to} to={item.to} onClick={() => setOpen(false)} className="block border-b border-line py-3 font-display text-2xl" data-id="element-190" data-mp="m243lq7uqkil">
              {item.label}
            </Link>)}
          <a href={contact.phoneHref} className="mt-4 block text-sm text-clay" data-id="element-191" data-mp="vy70ohnujsyo">
            {contact.phone}
          </a>
        </nav>}
    </header>;
}